"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jul 20 2018
 */

var immutable_1 = require("immutable");

var moment = require("moment");

var utils_1 = require("../../utils");

var ArrayDesc_1 = require("./ArrayDesc");

var DataPropDesc_1 = require("./DataPropDesc");

var FlagSetDesc_1 = require("./FlagSetDesc");

var ListDesc_1 = require("./ListDesc");

var MapDesc_1 = require("./MapDesc");

var ObjectPropDesc_1 = require("./ObjectPropDesc");

var OptionalDesc_1 = require("./OptionalDesc");

var Parser_1 = require("./Parser");

var DateParser_1 = require("./parsers/DateParser");

var TagParser_1 = require("./parsers/TagParser");

var PropDesc_1 = require("./PropDesc");

var SetDesc_1 = require("./SetDesc");
/**
 * Utility class for definition of data dictionary. The class contains shorthand for definition
 * of properties of simple type and basic collection types. In addition the builder is able
 * to generate property description `nameKey` as concatenation of base name and property name.
 *
 * @author Stepan Mik
 */


var StructPropBuilder =
/*#__PURE__*/
function () {
  /**
   * @param base base name for generated property nameKeys.
   */
  function StructPropBuilder(base) {
    _classCallCheck(this, StructPropBuilder);

    this.base = utils_1.Utils.isString(base) ? base : '';

    if (this.base.includes('_')) {
      throw new Error('Base cannot contain underscore characters!');
    }
  }

  _createClass(StructPropBuilder, [{
    key: "listOf",
    value: function listOf(item) {
      var _immutable_1$List;

      for (var _len = arguments.length, validators = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        validators[_key - 1] = arguments[_key];
      }

      return new ListDesc_1.ListDesc(item, item.description, (_immutable_1$List = immutable_1.List).of.apply(_immutable_1$List, validators));
    }
  }, {
    key: "setOf",
    value: function setOf(item) {
      var _immutable_1$List2;

      for (var _len2 = arguments.length, validators = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        validators[_key2 - 1] = arguments[_key2];
      }

      return new SetDesc_1.SetDesc(item, item.description, (_immutable_1$List2 = immutable_1.List).of.apply(_immutable_1$List2, validators));
    }
  }, {
    key: "arr",
    value: function arr(item) {
      var _immutable_1$List3;

      for (var _len3 = arguments.length, validators = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        validators[_key3 - 1] = arguments[_key3];
      }

      return new ArrayDesc_1.ArrayDesc(item, item.description, (_immutable_1$List3 = immutable_1.List).of.apply(_immutable_1$List3, validators));
    }
  }, {
    key: "smap",
    value: function smap(item) {
      var _immutable_1$List4;

      for (var _len4 = arguments.length, validators = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        validators[_key4 - 1] = arguments[_key4];
      }

      return new MapDesc_1.MapDesc(item, item.description, (_immutable_1$List4 = immutable_1.List).of.apply(_immutable_1$List4, validators));
    }
  }, {
    key: "lookup",
    value: function lookup(name, sequence) {
      var _immutable_1$List5;

      for (var _len5 = arguments.length, validators = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        validators[_key5 - 2] = arguments[_key5];
      }

      return new PropDesc_1.PropDesc(new Parser_1.StringParser(), {
        nameKey: this.nameKey(name),
        lookup: sequence
      }, (_immutable_1$List5 = immutable_1.List).of.apply(_immutable_1$List5, validators));
    }
  }, {
    key: "str",
    value: function str(name) {
      var _immutable_1$List6;

      for (var _len6 = arguments.length, validators = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        validators[_key6 - 1] = arguments[_key6];
      }

      return new PropDesc_1.PropDesc(new Parser_1.StringParser(), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List6 = immutable_1.List).of.apply(_immutable_1$List6, validators));
    }
  }, {
    key: "trimStr",
    value: function trimStr(name) {
      var _immutable_1$List7;

      for (var _len7 = arguments.length, validators = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        validators[_key7 - 1] = arguments[_key7];
      }

      return new PropDesc_1.PropDesc(new Parser_1.StringTrimParser(), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List7 = immutable_1.List).of.apply(_immutable_1$List7, validators));
    }
  }, {
    key: "multilineStr",
    value: function multilineStr(name) {
      var _immutable_1$List8;

      for (var _len8 = arguments.length, validators = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        validators[_key8 - 1] = arguments[_key8];
      }

      return new PropDesc_1.PropDesc(new Parser_1.StringParser(), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List8 = immutable_1.List).of.apply(_immutable_1$List8, validators));
    }
  }, {
    key: "id",
    value: function id(name) {
      var _immutable_1$List9;

      for (var _len9 = arguments.length, validators = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        validators[_key9 - 1] = arguments[_key9];
      }

      //new IdValidator()
      return new PropDesc_1.PropDesc(new Parser_1.StringParser(), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List9 = immutable_1.List).of.apply(_immutable_1$List9, validators));
    }
  }, {
    key: "opt",
    value: function opt(base) {
      return new OptionalDesc_1.OptionalDesc(base.description, base);
    }
  }, {
    key: "num",
    value: function num(name) {
      var _immutable_1$List10;

      for (var _len10 = arguments.length, validators = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        validators[_key10 - 1] = arguments[_key10];
      }

      return new PropDesc_1.PropDesc(new Parser_1.NumberParser(), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List10 = immutable_1.List).of.apply(_immutable_1$List10, validators));
    }
  }, {
    key: "bigNum",
    value: function bigNum(name) {
      var _immutable_1$List11;

      for (var _len11 = arguments.length, validators = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        validators[_key11 - 1] = arguments[_key11];
      }

      return new PropDesc_1.PropDesc(new Parser_1.BigNumberParser(), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List11 = immutable_1.List).of.apply(_immutable_1$List11, validators));
    }
  }, {
    key: "bool",
    value: function bool(name) {
      var _immutable_1$List12;

      for (var _len12 = arguments.length, validators = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        validators[_key12 - 1] = arguments[_key12];
      }

      return new PropDesc_1.PropDesc(new Parser_1.BooleanParser(), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List12 = immutable_1.List).of.apply(_immutable_1$List12, validators));
    }
  }, {
    key: "senum",
    value: function senum(name, enumVal, sequence) {
      var _immutable_1$List13;

      for (var _len13 = arguments.length, validators = new Array(_len13 > 3 ? _len13 - 3 : 0), _key13 = 3; _key13 < _len13; _key13++) {
        validators[_key13 - 3] = arguments[_key13];
      }

      //new EnumValidator()
      return new PropDesc_1.PropDesc(new Parser_1.EnumParser(enumVal), {
        nameKey: this.nameKey(name),
        lookup: sequence
      }, (_immutable_1$List13 = immutable_1.List).of.apply(_immutable_1$List13, validators));
    }
    /**
     * Provides property description for FlagSet properties.
     * @param name name of the property
     * @param base base ADT type of flagSet stored in the set
     * @param validators validators to be applied during property parsing.
     */

  }, {
    key: "flags",
    value: function flags(name, base) {
      var _immutable_1$List14;

      for (var _len14 = arguments.length, validators = new Array(_len14 > 2 ? _len14 - 2 : 0), _key14 = 2; _key14 < _len14; _key14++) {
        validators[_key14 - 2] = arguments[_key14];
      }

      return new FlagSetDesc_1.FlagSetDesc(base, {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List14 = immutable_1.List).of.apply(_immutable_1$List14, validators));
    }
    /**
     * Creates object property that is parsed according to provided DataDesc, usable for interfaces not classes.
     * @param name name of property
     * @param desc desc structure describing structure of required data.
     * @param validators validators to be applied during property parsing.
     * @see DataDescParser
     * @returns Object property descriptor that specifies data structured after `desc` and validated by provided validators.
     */

  }, {
    key: "data",
    value: function data(name, desc) {
      var _immutable_1$List15;

      for (var _len15 = arguments.length, validators = new Array(_len15 > 2 ? _len15 - 2 : 0), _key15 = 2; _key15 < _len15; _key15++) {
        validators[_key15 - 2] = arguments[_key15];
      }

      return new DataPropDesc_1.DataPropDesc(desc, new Parser_1.DataDescParser(desc), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List15 = immutable_1.List).of.apply(_immutable_1$List15, validators));
    }
    /**
     * Creates object property that is parsed according to provided ObjectDesc and transformed to proper object type by
     * provided transformer.
     * @param name name of property
     * @param desc desc object describing structure of required data.
     * @param xform function that transform plain object having same attributes as T to instance of T. The function usually
     *  creates new instance of T by applying new operator.
     * @param validators validators to be applied during property parsing.
     * @see ObjectDescParser
     * @returns Object property descriptor that specifies data structured after `desc` , transformed by `xlat` and validated by
     *  provided validators.
     */

  }, {
    key: "obj",
    value: function obj(name, desc, xform) {
      var _immutable_1$List16;

      for (var _len16 = arguments.length, validators = new Array(_len16 > 3 ? _len16 - 3 : 0), _key16 = 3; _key16 < _len16; _key16++) {
        validators[_key16 - 3] = arguments[_key16];
      }

      return new ObjectPropDesc_1.ObjectPropDesc(desc, new Parser_1.ObjectDescParser(desc, xform), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List16 = immutable_1.List).of.apply(_immutable_1$List16, validators));
    }
    /**
     * Creates object property that is parsed according to provided ObjectDesc and transformed to proper object type
     * by prototype manipulation - usable only for classes without private or protected fields. Note that class constructor
     * IS NOT CALLED, only prototype chain is altered. Use at your own risk.
     * Works same way as #obj method, with synthesized transformer.
     * @param name name of property
     * @param desc desc object describing structure of required data.
     * @param ctor constructor of class T. It is used to change prototype of input object.
     * @param validators validators to be applied during property parsing.
     * @see ObjectDescParser
     * @returns Object property descriptor that specifies data structured after `desc` , mutated to `ctor` and validated by
     *  provided validators.
     */

  }, {
    key: "objc",
    value: function objc(name, desc, ctor) {
      var _immutable_1$List17;

      var xform = function xform(mat) {
        Object.setPrototypeOf(mat, ctor.prototype);
        return mat;
      };

      for (var _len17 = arguments.length, validators = new Array(_len17 > 3 ? _len17 - 3 : 0), _key17 = 3; _key17 < _len17; _key17++) {
        validators[_key17 - 3] = arguments[_key17];
      }

      return new ObjectPropDesc_1.ObjectPropDesc(desc, new Parser_1.ObjectDescParser(desc, xform), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List17 = immutable_1.List).of.apply(_immutable_1$List17, validators));
    }
  }, {
    key: "date",
    value: function date(name, pattern) {
      var _immutable_1$List18;

      if (pattern === null || pattern === undefined) {
        pattern = moment.localeData().longDateFormat('L');
      }

      for (var _len18 = arguments.length, validators = new Array(_len18 > 2 ? _len18 - 2 : 0), _key18 = 2; _key18 < _len18; _key18++) {
        validators[_key18 - 2] = arguments[_key18];
      }

      return new PropDesc_1.PropDesc(new DateParser_1.DateParser(pattern), {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List18 = immutable_1.List).of.apply(_immutable_1$List18, validators));
    }
    /**
     * Create description of property based on provided parser and validators. This method should be use as a last resort in case
     * that no other methods of StructPropBuilder fit expected purpose.
     * @param name name of property
     * @param parser explicitly selected parser
     * @param validators validators to be applied during property parsing.
     */

  }, {
    key: "custom",
    value: function custom(name, parser) {
      var _immutable_1$List19;

      for (var _len19 = arguments.length, validators = new Array(_len19 > 2 ? _len19 - 2 : 0), _key19 = 2; _key19 < _len19; _key19++) {
        validators[_key19 - 2] = arguments[_key19];
      }

      return new PropDesc_1.PropDesc(parser, {
        nameKey: this.nameKey(name)
      }, (_immutable_1$List19 = immutable_1.List).of.apply(_immutable_1$List19, validators));
    }
  }, {
    key: "tag",
    value: function tag(name, type) {
      return new PropDesc_1.PropDesc(new TagParser_1.TagParser(type), {
        nameKey: this.nameKey(name)
      });
    }
  }, {
    key: "nameKey",
    value: function nameKey(name) {
      return !this.base.length ? name : this.base + '_' + name;
    }
  }], [{
    key: "nameId",
    value: function nameId(nameKey) {
      return nameKey.indexOf('_') ? nameKey.split('_')[1] : nameKey;
    }
  }]);

  return StructPropBuilder;
}();

exports.StructPropBuilder = StructPropBuilder;